import { render, staticRenderFns } from "./panier.vue?vue&type=template&id=2dc677cd"
import script from "./panier.vue?vue&type=script&lang=js"
export * from "./panier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports